module.exports = __webpack_public_path__ + "img/example_glass_01.61624469.png";